// import { Video } from "../../../libs/roomnew";
import { kinoParticipants, room,screenShare,Video } from "../../../libs/roomnew";
import { attachTrackToSmallPlayer, removeSmallPlayer } from "../../screen-share/ScreenshareUI";
import { updateVideoQuality } from "../video-quality/actions";
import { MEDIA_TYPE } from "./constants";
import { emitLocalTrackAdded, emitLocalTrackRemoved, emitRemoteTrackAdded, emitRemoteTrackMuteChanged, emitRemoteTrackRemoved, emitScreenshareTrackAdded, emitScreenshareTrackMuteChanged, emitScreenshareTrackRemoved, emitTrackStreamingStatusChanged } from "./eventDispatcher";
import { onScreenshareTrackMuteChanged } from "./events";

//track functions
const TRACKS={
    local:[],
    remote:[]
};

export const storeLocalTrack=(kinoTrack)=>{
    if(!kinoTrack.isLocal()){
        return
    }
    const pid = kinoTrack.getParticipantId();
    const screenshare=kinoTrack.getVideoType() === MEDIA_TYPE.DESKTOP;
    const mediaType=kinoTrack.getVideoType() == MEDIA_TYPE.DESKTOP ? MEDIA_TYPE.SCREENSHARE : kinoTrack.getType();

    const track={
        kinoTrack: kinoTrack,
        pid: pid,
        local: true,
        muted: screenshare ? false : kinoTrack.isMuted(),
        type: mediaType,
        screenshare: screenshare
    };
    const localTracks=TRACKS.local.filter(t=>t.type != mediaType);
    TRACKS.local = [...localTracks,track];
    if (mediaType === MEDIA_TYPE.AUDIO) {
        console.log('[MIC-DIAG] storeLocalTrack:audio', {
            wrapperMuted: track.muted,
            kinoTrackMuted: kinoTrack.isMuted(),
            localTracksCount: TRACKS.local.length,
        });
    }
    console.log("Local track after new track add",TRACKS.local)
    emitLocalTrackAdded(track);
}

export const removeLocalTrack=(kinoTrack)=>{
    const removeTrack=findLocalTrack(kinoTrack);
    TRACKS.local=TRACKS.local.filter(t=>t.kinoTrack !== kinoTrack);
    console.log("%c[EVENT]%c","color:red","color:unset"," remove local tracks",removeTrack)
    if(removeTrack){
        emitLocalTrackRemoved(removeTrack);
    }
}

export const removeMutedLocalVideoTrack=async ()=>{
    // const desktopTrack = getLocalTrack(MEDIA_TYPE.SCREENSHARE)
    // const activeVideoTrack = getLocalTrack(MEDIA_TYPE.VIDEO);
    // console.log("LAST USER DROPPED, removig non active tracks, active track",activeVideoTrack)

    // if(desktopTrack || screenShare.isSharing()){
    //     if(screenShare.isSharing()){
    //         await screenShare.stop();
    //     }
    //     const toRemove = TRACKS.local.filter(t=> t.type !== MEDIA_TYPE.AUDIO && t.kinoTrack !== activeVideoTrack.kinoTrack);
    //     console.log("Remove inactive tracks",toRemove)
    //     if(toRemove){
    //         try {
    //             toRemove.forEach(track=>{
    //                 room.removeTrack(track.kinoTrack);
    //                 removeLocalTrack(track.kinoTrack);
    //             })
    //         } catch (error) {
    //             console.error("Unable to remove muted track",error)
    //         }
    //     }

    // }
}

export const addRemoteTrack=(kinoTrack)=>{
    if(kinoTrack.isLocal()){
        return
    }
    console.log(`[TRACK_ADDED] video type:`,kinoTrack.getVideoType(),'media type ',kinoTrack.getType(),' muted ',kinoTrack.isMuted())
    const pid = kinoTrack.getParticipantId();
    const screenshare=kinoTrack.getVideoType() == MEDIA_TYPE.DESKTOP;
    const mediaType=kinoTrack.getVideoType() == MEDIA_TYPE.DESKTOP ? MEDIA_TYPE.SCREENSHARE : kinoTrack.getType();
    // let videoTypeChanged=false;
    const srcName= kinoTrack?.getSourceName();
    // TODO screenshare track is not removed when video track is added
    // if(mediaType==MEDIA_TYPE.SCREENSHARE){
    //     const videoTrack=getRemoteParticipantTrack(pid,MEDIA_TYPE.VIDEO);
    //     if(videoTrack && videoTrack.kinoTrack){
    //         //remove event listeners for video suspended since we have a nother video track
    //         videoTrack.kinoTrack.track.onmute=null;
    //         videoTrack.kinoTrack.track.onunmute=null;
    //     }
    // }


    const track={
        kinoTrack: kinoTrack,
        pid: pid,
        local: false,
        muted: kinoTrack.isMuted(),
        srcName: kinoTrack?.getSourceName(),
        type: mediaType,
        screenshare: screenshare,
        status: kinoTrack.getTrackStreamingStatus()
    };
    if(mediaType==MEDIA_TYPE.VIDEO || mediaType == MEDIA_TYPE.SCREENSHARE){
        kinoTrack.on(KinoJS.events.track.TRACK_STREAMING_STATUS_CHANGED,onStreamingStatusChanged);
        kinoTrack.on(KinoJS.events.track.TRACK_VIDEOTYPE_CHANGED,type => trackVideoTypeChanged(track,type))
    }
    const remoteTracks=TRACKS.remote.filter(t=> (t.pid != pid) || t.type != mediaType || t.srcName != srcName);
    TRACKS.remote =[...remoteTracks,track];
    console.log("Remote tracks after new track added",TRACKS.remote)
    if(screenshare){
        emitScreenshareTrackAdded(track);
        updateVideoQuality(false,true)
    }else{
        emitRemoteTrackAdded(track);
        if(mediaType == MEDIA_TYPE.VIDEO){
            updateVideoQuality(false,true)
        }
    }
}

export const trackVideoTypeChanged=(track,type)=>{
    console.log("[VIDEO TYPE CHANGED] track video type changed ",type)
    const screenshare=type === MEDIA_TYPE.DESKTOP;
    const mediaType = screenshare ? MEDIA_TYPE.SCREENSHARE : MEDIA_TYPE.VIDEO;
    track.type = mediaType;
    track.screenshare = screenshare;
    if(screenshare){
        // Video.cameraMuted(track.pid,false)
        // Video.attachVideoToPlayer(track.pid, track.kinoTrack);
        onScreenshareTrackMuteChanged(track);

    }

    // if(Video.videos[track.pid]){
    //     Video.videos[track.pid].videoTypeChanged(type)
    // }
    updateVideoQuality(false,true)
}
export const onStreamingStatusChanged=(kinoTrack,streamingStatus)=>{
    const track=TRACKS.remote.find(t=>t.kinoTrack === kinoTrack);
    if(track){
        track.status=streamingStatus;
        console.log("[EVENT] streaming status",streamingStatus)
        emitTrackStreamingStatusChanged(track,streamingStatus)
    }
}
export const removeRemoteTrack=(kinoTrack)=>{
    const track=TRACKS.remote.find(t=>t.kinoTrack === kinoTrack);
    if(track){
        const pid = kinoTrack.getParticipantId();
        const screenshare=kinoTrack.getVideoType() === MEDIA_TYPE.DESKTOP;
        if(kinoTrack.getType() == MEDIA_TYPE.VIDEO){
            track.kinoTrack.off(KinoJS.events.track.TRACK_STREAMING_STATUS_CHANGED,onStreamingStatusChanged)
            track.kinoTrack.off(KinoJS.events.track.TRACK_VIDEOTYPE_CHANGED,trackVideoTypeChanged)
        }
        // const mediaType=kinoTrack.getType() == MEDIA_TYPE.DESKTOP ? MEDIA_TYPE.SCREENSHARE : kinoTrack.getType();
        console.log("Found remote track to remove",track)
        TRACKS.remote=TRACKS.remote.filter(t=>t.kinoTrack !== kinoTrack);
        if(screenshare){
            emitScreenshareTrackRemoved(track)
        }else{
            emitRemoteTrackRemoved(track);
        }
    }else{
        console.log("Remote track not found to remove")
    }
}

export const remoteTrackMuteChanged=(kinoTrack)=>{
    console.log("Remote track ",kinoTrack)
    const pid=kinoTrack.getParticipantId();
    const track= kinoTrack.isLocal() ? findLocalTrack(kinoTrack) : findTrackByKinoTrack(pid,kinoTrack);
    if(track){
        track.muted=kinoTrack.isMuted();
        if (track.type == MEDIA_TYPE.AUDIO) {
                console.log(
                    `[MIC-DIAG] remoteTrackMuteChanged:audio local=${track.local} pid=${track.pid} muted=${track.muted}`
                );
                if (track.muted &&  !track.local) {
                        Video.speaker.removeSpeaker(track.pid);
                }
                if (track.local) {
                        try {
                                room.setLocalParticipantProperty('audio_muted', track.muted ? 'true' : 'false');
                        } catch (error) { console.error("[Kino Error] [functions]", error); }
                }
                Video.micMuted(track.local ? 'local': track.pid, track.muted);
        } else if(track.type == MEDIA_TYPE.SCREENSHARE){
            if(!track.local){
                emitScreenshareTrackMuteChanged(track);
            }else{
                if(track.muted){
                    try {
                        room.setSenderVideoConstraint(720);
                    } catch (error) { console.error("[Kino Error] [functions]", error); }
                }
            }
        }else{
            if(!track.local){
                emitRemoteTrackMuteChanged(track);
            }
        }
            // Video.cameraMuted(track.pid, track.muted);
    }else{
        console.log("Cannot find track from kinoTrack",kinoTrack)
    }
}

export const remoteCameraMutedWeb=(user,muted)=>{
    const pid=user.getId();
    const videoTrack = getRemoteParticipantTrack(pid,MEDIA_TYPE.VIDEO);
    // const desktopTrack=getRemoteParticipantDesktopTrack(pid);
    // console.log("Remote camera muted",videoTrack,desktopTrack)
    if(videoTrack && videoTrack.muted != muted){
        videoTrack.muted=muted;
        emitRemoteTrackMuteChanged(videoTrack);
    }else{
        const desktopTrack=getRemoteParticipantDesktopTrack(pid);
        if(!desktopTrack){
            Video.cameraMuted(pid,muted)
        }
    }
}

export const getRemoteParticipantTrack=(pid,mediaType)=>{
    return TRACKS.remote.find(t=>t.pid==pid && t.type == mediaType)
}

export const getLocalTrack=(mediaType)=>{
    return TRACKS.local.find(t=>t.type === mediaType)
}
export const getLocalKinoTrack=(mediaType)=>{
    const track=TRACKS.local.find(t=>t.type === mediaType);
    return track?.kinoTrack
}
export const getLocalMainVideoTrack=()=>{
    const tracks=TRACKS.local.filter(t=>t.type == MEDIA_TYPE.VIDEO || MEDIA_TYPE.SCREENSHARE);
    const desktopTrack=tracks.find(t=>t.type == MEDIA_TYPE.SCREENSHARE && !t.muted);
    if(desktopTrack) {return desktopTrack}
    const videoTrack=tracks.find(t=>t.type == MEDIA_TYPE.VIDEO);
    return videoTrack;
}
export const getLocalMainKinoTrack=()=>{
    const tracks=TRACKS.local.filter(t=>t.type == MEDIA_TYPE.VIDEO || MEDIA_TYPE.SCREENSHARE);
    const desktopTrack=tracks.find(t=>t.type == MEDIA_TYPE.SCREENSHARE && !t.muted);
    if(desktopTrack) {return desktopTrack?.kinoTrack}
    const videoTrack=tracks.find(t=>t.type == MEDIA_TYPE.VIDEO);
    return videoTrack?.kinoTrack;
}

export const findLocalTrack=(kinoTrack)=>{
    return TRACKS.local.find(t=>t.kinoTrack === kinoTrack)
}
export const getLocalDesktopTrack=()=>{
    return TRACKS.local.find(t=>t.type === MEDIA_TYPE.SCREENSHARE && !t.muted)
}
export const findTrackByKinoTrack=(pid,kinoTrack)=>{
    return TRACKS.remote.find(t=>t.pid==pid && t.kinoTrack == kinoTrack)
}
export const getRemoteParticipantDesktopTrack=(pid)=>{
    return TRACKS.remote.find(t=>t.pid==pid && t.type == MEDIA_TYPE.SCREENSHARE && !t.muted)
}

export const getRemoteParticipantMainVideoTrack=(pid)=>{
    const tracks=TRACKS.remote.filter(t=>(t.pid == pid) && (t.type == MEDIA_TYPE.VIDEO || MEDIA_TYPE.SCREENSHARE));
    const desktopTrack=tracks.find(t=>t.type == MEDIA_TYPE.SCREENSHARE && !t.muted);
    if(desktopTrack) {return desktopTrack}
    const videoTrack=tracks.find(t=>t.type == MEDIA_TYPE.VIDEO);
    return videoTrack;
}
export const getRemoteParticipantMainKinoTrack=(pid)=>{
    const tracks=TRACKS.remote.filter(t=>(t.pid == pid) && (t.type == MEDIA_TYPE.VIDEO || MEDIA_TYPE.SCREENSHARE));
    const desktopTrack=tracks.find(t=>t.type == MEDIA_TYPE.SCREENSHARE && !t.muted);
    if(desktopTrack) {return desktopTrack.kinoTrack}
    const videoTrack=tracks.find(t=>t.type == MEDIA_TYPE.VIDEO);
    return videoTrack?.kinoTrack;
}

export const getLocalTracks=()=>{
    return TRACKS.local;
}

export const addLocalTrack=async (newTrack)=>{
        if (room) {
            await room.addTrack(newTrack);
        }

        const setMuted = newTrack.isVideoTrack()
            ? getMultipleVideoSendingSupportFeatureFlag(getState())
            && newTrack.getVideoType() === VIDEO_TYPE.DESKTOP
                ? setScreenshareMuted
                : setVideoMuted
            : setAudioMuted;
        const isMuted = newTrack.isMuted();

        logger.log(`Adding ${newTrack.getType()} track - ${isMuted ? 'muted' : 'unmuted'}`);
        await dispatch(setMuted(isMuted));

        return dispatch(_addTracks([ newTrack ]));
}

export const removeLocalVideoTrack=async ()=>{
    const videoTrack = getLocalTrack(MEDIA_TYPE.VIDEO)
    if(room && videoTrack){
        await room.removeTrack(videoTrack.kinoTrack);
    }
    removeLocalTrack(videoTrack.kinoTrack);
}

export const setScreenshareMuted=async (muted)=>{
    const desktopTrack=getLocalTrack(MEDIA_TYPE.SCREENSHARE);
    console.log("Muting desktop track",desktopTrack)
    if(desktopTrack && desktopTrack.kinoTrack){
        if(muted){
            if(Object.keys(Video.videos).length==0){
                try {
                    await room.removeTrack(desktopTrack.kinoTrack);
                    return
                } catch (error) { console.error("[Kino Error] [functions]", error); }
            }
            desktopTrack.kinoTrack.mute();
            try {
                if(desktopTrack.kinoTrack._streamEffect){
                    desktopTrack.kinoTrack._streamEffect.stopEffect();
                    desktopTrack.kinoTrack.stream.getTracks().map(t=>t.stop());
                    desktopTrack.kinoTrack._originalStream.getTracks().map(t=>t.stop());
                }else{
                    desktopTrack.kinoTrack.stream.getTracks().map(t=>t.stop());
                }
            } catch (error) {
                console.error("Mute screenshare track error",error)
            }

        }else if(!muted && desktopTrack.kinoTrack.isMuted()){
            desktopTrack.kinoTrack.unmute();
        }
        desktopTrack.muted=muted;
    }
}

export const setLocalVideoMuted=(muted)=>{
    const videoTrack=getLocalTrack(MEDIA_TYPE.VIDEO);
    if(videoTrack && videoTrack.kinoTrack){
        if(muted && !videoTrack.kinoTrack.isMuted()){
            videoTrack.kinoTrack.mute();
        }else if(!muted && videoTrack.kinoTrack.isMuted()){
            videoTrack.kinoTrack.unmute();
        }
        videoTrack.muted=muted;
        if(screenShare.isSharing()){
            if(muted){
                removeSmallPlayer(kinoParticipants.me());
            }else{
                attachTrackToSmallPlayer(kinoParticipants.me(),videoTrack);
            }
        }
    }
}

const getTrackSourceNameByMediaTypeAndParticipant=(mediaType,pid)=>{
    const track=TRACKS.remote.find(t=>t.type == mediaType && t.pid==pid);
    return track?.kinoTrack?.getSourceName()
}

export const setSenderMaxFramerate=(framerate)=>{
    const kinoTrack = getLocalKinoTrack(MEDIA_TYPE.VIDEO);
    console.log("Set sender max framerate",kinoTrack)
    if(kinoTrack?.track){
        kinoTrack.track.applyConstraints({
            frameRate:{
                 max:framerate,
                 ideal:framerate
             }
        });
        let settings = kinoTrack.track.getConstraints();
        console.log("Sender Constraints settings",settings);
    }
}

export const _getSourceNames=(participantList)=>{
    if(!participantList || participantList.lenght == 0){return []}
    const remoteScreenShares=TRACKS.remote.filter(t=>t.type == MEDIA_TYPE.SCREENSHARE && !t.muted).map(t=>t.pid);
    const sourceNamesList=[];

    participantList.forEach(participantId => {
        // let sourceName;
        let hasScreenshare = remoteScreenShares.includes(participantId);
        if (hasScreenshare) {
            const desktopSourceName = {name:getTrackSourceNameByMediaTypeAndParticipant(MEDIA_TYPE.SCREENSHARE, participantId),screenshare:true,force180p:false};
            if (desktopSourceName?.name) {
                sourceNamesList.push(desktopSourceName);
            }
        }

        const videoSourceName = {name:getTrackSourceNameByMediaTypeAndParticipant(MEDIA_TYPE.VIDEO, participantId),screenshare:false,force180p:hasScreenshare};
        if (videoSourceName?.name) {
            sourceNamesList.push(videoSourceName);
        }

    });

    return sourceNamesList;
}
